export default __webpack_public_path__ + "static/media/vcCircle.9ed68f10.jpeg";